export class BlogService {
  constructor($http) {
    this.http = $http;
  }

  getBlogs(page, limit) {
    return this.http.get(`/api/blog/all/${page}/${limit}`);
  }

  getMyBlogs(page, limit) {
    return this.http.get(`/api/blog/my/${page}/${limit}`);
  }

  getBlogByRating(page, limit) {
    return this.http.get(`/api/blog/rating/${page}/${limit}`);
  }

  getBlogsWithComments(page, limit) {
    return this.http.get(`/api/blog/user/comments/${page}/${limit}`);
  }

  getSelectBlog(id) {
    return this.http.get(`/api/blog/select/${id}`);
  }

  getSelectBlogComments(blog, page, limit) {
    return this.http.get(`/api/blog/comments/${blog}/${page}/${limit}`);
  }

  createBlog(newBlog) {
    return this.http.post('/api/blog', newBlog)
  }

  getCategories() {
    return this.http.get('/api/category/blog');
  }

  getAllBlogs(page, limit, query) {
    var params = {
      page: page,
      limit: limit,
      query: query
    };

    return this.http.post('/api/blog/all', params);
  }

  getUnconfirmedBlogs(page, limit) {
    return this.http.get('/api/blog/unconfirmed/'+page+'/'+limit);
  }

  approveBlog(id) {
    return this.http.get('/api/blog/approve/'+id);
  }

  rejectBlog(id, message) {
    return this.http.put('/api/blog/reject/'+id, message);
  }

  updateBlog(blog) {
    return this.http.put('/api/blog/' + blog._id, blog);
  }

  removeBlog(id) {
    return this.http.delete('/api/blog/' + id);
  }

  getCommentReprts(filtr, page, limit) {
    return this.http.get("/api/comment/report/" + filtr + "/" + page + "/" + limit);
  }

  likeComment(params) {
    return this.http.post("/api/comment/blog/rate", params)
  }

  deleteComment(key) {
    return this.http.delete('/api/comment/blog/' + key);
  }
  
  createReport(param) {
    return this.http.post('/api/comment/report', param);
  }

  deleteCommentReport(key) {
    return this.http.delete('/api/comment/report/' + key);
  }
}
